var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MyManage',[_c('el-tabs',{attrs:{"type":"border-card"},model:{value:(_vm.activeName),callback:function ($$v) {_vm.activeName=$$v},expression:"activeName"}},[[_c('el-tab-pane',{attrs:{"label":_vm.$t('xiang-bian-guan-li'),"name":"gunBox"}},[(_vm.activeName=='gunBox')?_c('GunBoxPage'):_vm._e()],1)]],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a365d68c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/module/resourceCenter/page/gunBoxManage.vue
// module id = null
// module chunks = 